// @ts-check
// Nomes de API derivados de rótulos em pt-BR (doc 04, seções 2.2 e 2.4), usados pela tela de modelo de dados.
// Mesmo comportamento do Twenty: acentos removidos, camelCase para objetos e campos, UPPER_SNAKE_CASE para opções.

const METADATA_NAME_MAX_LENGTH = 63;

/** @param {string} text */
const splitWords = (text) => text
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .replace(/[^a-zA-Z0-9]+/g, ' ')
  .trim()
  .split(' ')
  .filter(Boolean);

/**
 * "Tamanho do uniforme" vira "tamanhoDoUniforme"; rótulo que começa com dígito ganha prefixo "n".
 * @param {string} label
 */
export function computeMetadataNameFromLabel(label) {
  const words = splitWords(label ?? '');
  if (words.length === 0) return '';
  const name = words
    .map((word, index) => {
      const lower = word.toLowerCase();
      return index === 0 ? lower : lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join('');
  return (/^[0-9]/.test(name) ? `n${name}` : name).slice(0, METADATA_NAME_MAX_LENGTH);
}

/**
 * "Visita agendada" vira "VISITA_AGENDADA"; rótulo que começa com dígito ganha prefixo "OPTION_".
 * @param {string} label
 */
export function computeOptionValueFromLabel(label) {
  const value = splitWords(label ?? '').map((word) => word.toUpperCase()).join('_');
  if (value === '') return '';
  return (/^[0-9]/.test(value) ? `OPTION_${value}` : value).slice(0, METADATA_NAME_MAX_LENGTH);
}

/**
 * Valor de opção ainda não usado na lista: acrescenta _2, _3... quando o rótulo repete.
 * @param {string} label @param {Iterable<string>} takenValues
 */
export function computeUniqueOptionValue(label, takenValues) {
  const taken = new Set(takenValues);
  const base = computeOptionValueFromLabel(label) || 'OPTION';
  if (!taken.has(base)) return base;
  let suffix = 2;
  while (taken.has(`${base}_${suffix}`)) suffix += 1;
  return `${base}_${suffix}`;
}
